import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=4bc5770a&scoped=true&lang=pug&"
import script from "./ResourcesList.vue?vue&type=script&lang=js&"
export * from "./ResourcesList.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&id=4bc5770a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5770a",
  null
  
)

export default component.exports